if (!customElements.get('roi-calculator')) {
  customElements.define('roi-calculator', class RoiCalculator extends HTMLElement {
    connectedCallback() {
      this.chart1 = null;
      this.activeCalculator = 'hiring';
      this.selectedMowerCost = 2699;
      this.selectedYears = 5;

      this.initButton();
      this.initSelections();
      this.initRangeBarSlide();
      this.initCharts();
      this.activateDefaultPresets();
      this.updateTotals();
    }

    formatCurrency(amount) {
      return `$${Number(amount || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    }

    initButton() {
      const buttons = this.querySelectorAll('.roi-calculator-button');
      const hiaringBtn = this.querySelectorAll('.hiaring-cost-calculator-button');
      const diyBtn = this.querySelectorAll('.diy-cost-calculator-button');

      buttons.forEach(button => {
        button.addEventListener('click', () => {
          buttons.forEach(b => b.classList.remove('active'));
          button.classList.add('active');
        });
      });

      hiaringBtn.forEach(btn => {
        btn.addEventListener('click', () => {
          this.activeCalculator = 'hiring';
          this.querySelector('.hiaring-cost-calculator')?.classList.remove('hidden');
          this.querySelector('.diy-cost-calculator')?.classList.add('hidden');
          this.updateTotals();
        });
      });

      diyBtn.forEach(btn => {
        btn.addEventListener('click', () => {
          this.activeCalculator = 'diy';
          this.querySelector('.diy-cost-calculator')?.classList.remove('hidden');
          this.querySelector('.hiaring-cost-calculator')?.classList.add('hidden');
          this.updateTotals();
        });
      });

      const products = this.querySelectorAll('.roi-product');
      const roi_product_button = this.querySelector('.section-bottom-button');

      const updateButtonLink = (product) => {
        if (!product) return;
        const productUrl = product.dataset.url;
        const productPrice = product.dataset.price;
        if (productUrl && roi_product_button) roi_product_button.setAttribute('href', productUrl);
        if (productPrice) this.selectedMowerCost = parseInt(productPrice);
        this.updateTotals();
      };

      let activeProduct = this.querySelector('.roi-product.active');
      if (!activeProduct && products.length > 0) {
        activeProduct = products[3];
        activeProduct.classList.add('active');
      }
      updateButtonLink(activeProduct);

      products.forEach((product) => {
        product.addEventListener('click', () => {
          products.forEach(p => p.classList.remove('active'));
          product.classList.add('active');
          updateButtonLink(product);
        });
      });

      const yearButtons = this.querySelectorAll('.roi-total-year');
      yearButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          yearButtons.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          this.selectedYears = parseInt(btn.textContent.replace(/\D/g, ''));
          this.updateTotals();
        });
      });

      const hiringPresets = this.querySelectorAll('.hiaring-cost-calculator [data-roi-price-per-mow]');
      hiringPresets.forEach(btn => {
        btn.addEventListener('click', () => {
          hiringPresets.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          const section = this.querySelector('.hiaring-cost-calculator');
          this.setRangeValue(section, '.roi-price-per-mow', btn.dataset.roiPricePerMow);
          this.setRangeValue(section, '.roi-per-month-mows', btn.dataset.roiPerMonth);
          this.setRangeValue(section, '.roi-per-month-year', btn.dataset.roiPerMonthYear);
          this.updateTotals();
        });
      });

      const diyPresets = this.querySelectorAll('.diy-cost-calculator [data-roi-per-min]');
      diyPresets.forEach(btn => {
        btn.addEventListener('click', () => {
          diyPresets.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          const section = this.querySelector('.diy-cost-calculator');
          this.setRangeValue(section, '.roi-per-min-mow', btn.dataset.roiPerMin);
          this.updateTotals();
        });
      });
    }

    setRangeValue(section, selector, value) {
      const input = section.querySelector(selector);
      if (!input) return;
      input.value = value;
      const percentage = (input.value - input.min) / (input.max - input.min) * 100;
      input.style.setProperty('--data-range', `${percentage}%`);
      const display = input.closest('div').querySelector('.input-value');
      if (display) display.textContent = value;
    }

    activateDefaultPresets() {
      const medium = this.querySelector('.hiaring-cost-calculator [data-roi-price-per-mow="55"]');
      if (medium) medium.click();
      const normal = this.querySelector('.diy-cost-calculator [data-roi-per-min="60"]');
      if (normal) normal.click();
    }

    initSelections() {
      const products = this.querySelectorAll('.roi-product');
      if (products.length > 50) {
        products.forEach(p => p.classList.remove('active'));
        const defaultProduct = products[3];
        defaultProduct.classList.add('active');
        const priceEl = defaultProduct.querySelector('.roi-product-price');
        if (priceEl) this.selectedMowerCost = parseInt(priceEl.textContent.replace(/\D/g, ''));
      }

      const yearButtons = this.querySelectorAll('.roi-total-year');
      if (yearButtons.length) {
        yearButtons.forEach(btn => {
          if (btn.textContent.includes('5y')) {
            btn.classList.add('active');
            this.selectedYears = 5;
          } else {
            btn.classList.remove('active');
          }
        });
      }
    }

    initRangeBarSlide() {
      const inputs = this.querySelectorAll('.input-range');
      inputs.forEach(input => {
        const updateRange = () => {
          const percentage = (input.value - input.min) / (input.max - input.min) * 100;
          input.style.setProperty('--data-range', `${percentage}%`);
          const display = input.closest('div').querySelector('.input-value');
          if (display) display.textContent = input.value;
        };
        updateRange();
        input.addEventListener('input', () => {
          updateRange();
          this.updateTotals();
        });
      });
    }

    initCharts() {
      if (!window.echarts) return;
      const el = this.querySelector('.roi-echart-1');
      if (!el) return;

      this.chart1 = echarts.init(el);
      this.chart1.setOption({
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#1f1f1f',
          borderColor: '#333',
          textStyle: { color: '#fff' },
          formatter: params => {
            if (!Array.isArray(params) || !params.length) return '';
            const title = params[0].axisValueLabel || params[0].axisValue || '';
            const lines = params.map(item => `${item.marker}${item.seriesName}: ${this.formatCurrency(item.value)}`);
            return [title, ...lines].join('<br/>');
          }
        },
        legend: {
          bottom: 0,
          textStyle: { color: '#aaa' },
          itemWidth: 18,
          itemHeight: 3
        },
        grid: {
          left: 60,
          right: 20,
          top: 40,
          bottom: 60
        },
        xAxis: {
          type: 'category',
          boundaryGap: false, // Ensures lines touch the edges
          data: [],
          axisLine: { show: true, lineStyle: { color: '#444' } },
          axisTick: { show: false },
          axisLabel: { color: '#888' }
        },
        yAxis: {
          type: 'value',
          min: 0, // Ensures chart starts at $0 base
          axisLine: { show: true, lineStyle: { color: '#444' } },
          axisTick: { show: false },
          axisLabel: {
            color: '#888',
            formatter: value => `$${Number(value || 0).toLocaleString(undefined, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            })}`
          },
          splitLine: { lineStyle: { color: '#222' } }
        },
        series: [
          {
            name: 'Hiring',
            type: 'line',
            smooth: true,
            showSymbol: false,
            lineStyle: { width: 2, color: '#e5e5e5' },
            data: []
          },
          {
            name: 'Sunseeker mower',
            type: 'line',
            smooth: true,
            showSymbol: false,
            lineStyle: { width: 2, color: '#ff5a1f' },
            data: []
          }
        ]
      });

      window.addEventListener('resize', () => this.chart1.resize());
    }

    updateChart(hiringData, diyData, labels) {
      if (!this.chart1) return;
      this.chart1.setOption({
        xAxis: { data: labels },
        series: [
          { name: 'Hiring', data: hiringData },
          { name: 'Sunseeker mower', data: diyData }
        ]
      });
    }

    formatDuration(months) {
      if (months === 0) return '0';
      const years = Math.floor(months / 12);
      const remainingMonths = months % 12;
      if (years > 0 && remainingMonths > 0) return `${years}Y ${remainingMonths}M`;
      if (years > 0) return `${years}Y`;
      return `${remainingMonths}M`;
    }

    generateTimePoints(years, points = 10) {
      const totalMonths = years * 12;
      const stepMonths = totalMonths / points;
      
      // ✅ Start labels and months at 0
      const labels = ['0'];
      const monthsArr = [0];

      for (let i = 1; i <= points; i++) {
        const months = Math.round(stepMonths * i);
        monthsArr.push(months);
        labels.push(this.formatDuration(months));
      }

      return { labels, monthsArr };
    }

    updateTotals() {
      let totalCost = 0;
      let monthlyCost = 0;
      let perMonthYear = 0;

      const activeSection = this.activeCalculator === 'hiring'
        ? this.querySelector('.hiaring-cost-calculator')
        : this.querySelector('.diy-cost-calculator');

      if (!activeSection) return;

      const pricePerMow = parseFloat(activeSection.querySelector('.roi-price-per-mow')?.value || 0);
      const perMonthMows = parseFloat(activeSection.querySelector('.roi-per-month-mows')?.value || 0);
      perMonthYear = parseFloat(activeSection.querySelector('.roi-per-month-year')?.value || 0);
      const perHour = parseFloat(activeSection.querySelector('.roi-per-hour')?.value || 0);
      const perMinMow = parseFloat(activeSection.querySelector('.roi-per-min-mow')?.value || 0);

      if (this.activeCalculator === 'hiring') {
        totalCost = pricePerMow * perMonthMows * perMonthYear * this.selectedYears;
        monthlyCost = pricePerMow * perMonthMows;
      } else if (this.activeCalculator === 'diy') {
        const hoursPerMow = perMinMow / 60;
        totalCost = hoursPerMow * perHour * perMonthMows * perMonthYear * this.selectedYears;
        monthlyCost = hoursPerMow * perHour * perMonthMows;
      }

      const roiMowerEl = this.querySelector('.roi-mower-cost');
      const roiHiringEl = this.querySelector('.roi-hiaring-cost');
      const roiSaveEl = this.querySelector('.roi-save-ammount');
      const roiAvgEl = this.querySelector('.roi-avarage-amount');
      const roiSaveOverYear = this.querySelector('.save-over-by-year');
      const roiBreakEven = this.querySelector('.roi-break-even');

      if (roiSaveOverYear) roiSaveOverYear.textContent = this.selectedYears;
      if (roiMowerEl) roiMowerEl.textContent = this.formatCurrency(this.selectedMowerCost);
      if (roiHiringEl) roiHiringEl.textContent = this.formatCurrency(totalCost);

      let breakEvenMonths = null;
      if (monthlyCost > 0 && perMonthYear > 0) {
        const neededMowingMonths = this.selectedMowerCost / monthlyCost;
        const calendarMonths = neededMowingMonths * (12 / perMonthYear);
        breakEvenMonths = Math.ceil(calendarMonths);
      }
      if (roiBreakEven) roiBreakEven.textContent = breakEvenMonths ? this.formatDuration(breakEvenMonths) : '—';

      const savings = totalCost - this.selectedMowerCost;
      if (roiSaveEl) roiSaveEl.textContent = this.formatCurrency(savings);
      if (roiAvgEl) roiAvgEl.textContent = `Avg: $${(savings / (this.selectedYears * 12)).toFixed(2)}/mo`;

      // ✅ Generate Chart Data starting from 0
      const { labels, monthsArr } = this.generateTimePoints(this.selectedYears, 10);
      const diyData = monthsArr.map(months => {
        if (months === 0) return 0;
        return this.selectedMowerCost / months;
      });

      const hiringData = monthsArr.map(months => {
        if (months === 0) return 0; // ✅ White line starts at $0
        const year = Math.floor((months - 1) / 12);
        const monthInYear = ((months - 1) % 12) + 1;
        const chargedThisYear = Math.min(monthInYear, perMonthYear);
        const totalChargedMonths = year * perMonthYear + chargedThisYear;
        return totalChargedMonths * monthlyCost;
      });

      this.updateChart(hiringData, diyData, labels);
    }
  });
}
